import React from 'react'
import theme from '../utils/theme'
import styled from 'styled-components'
import LabelField from './LabelField'
import chevronDown from '/images/chevron-down.svg'

const SelectorComponent = styled.select`
    padding: 8px 35px 8px 10px;
    border: 1px solid ${ theme.palette.black };
    background-color: ${ theme.palette.white };
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("${chevronDown}");
    background-position: right 10px bottom 6px;
    background-repeat: no-repeat;
    font-family: ParisineOffice;
    color: ${ props => props.value ? theme.palette.black : theme.palette.grey };
    border-radius: 0;
    white-space: normal;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.155556px;
    &:focus {
    }
    &::-ms-expand {
      display: none;
    }
    &:disabled{
      background-color: ${ theme.palette.grey };
    }
    @media (max-width: ${ theme.breakpoints.mobile }) {
    }
`
const StyledSelector = ({ options, placeholder, onValueChange, children, getValue, getLabel, label, subLabel, direction, value, className, ...props }) => {

  return <LabelField label={ label } subLabel={ subLabel } direction={ direction }>
    <SelectorComponent aria-invalid="false"
                       onChange={ (e) => {
                         onValueChange(e.target.value)
                       } }
                       className={ className }
                       value={ placeholder && !value ? '' : value }
                       { ...props }>
      { placeholder && <option value="" disabled hidden>{ placeholder }</option> }
      { Array.isArray(options) && options.map((item, index) => {
        let value, label
        if (item instanceof Object) {
          value = getValue ? getValue(item) : item.code
          label = getLabel ? getLabel(item) : item.name
        } else {
          value = item
          label = item
        }
        return <option style={{color: theme.palette.black}} key={ index } value={ value }>{ label }</option>
      })
      }
      { children }
    </SelectorComponent>
  </LabelField>
}

export default StyledSelector

export const ObjectSelector = ({ options, getKey, onValueChange, selected, ...props }) => {
  let value
  let getValue = getKey ? getKey : (item) => options.indexOf(item)
  if (selected instanceof Object) {
    value = getValue(selected)
  } else {
    value = selected
  }
  return <StyledSelector
    options={ options }
    getValue={ getValue }
    value={ value }
    onValueChange={ v => {
      const obj = options.filter(item => getValue(item) === v)[0]
      onValueChange && onValueChange(obj)
    } }
    { ...props }
  />
}
